import * as React from "react";
import { forwardRef } from "react";
const SvgIcWorks24 = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { width: 24, height: 24, viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("g", { id: "icSign-works" }, /* @__PURE__ */ React.createElement("path", { id: "Vector", fillRule: "evenodd", clipRule: "evenodd", d: "M10.157 2H13.843L19.0409 20H21L22 21V22H2V21L3 20H4.95918L10.157 2ZM10.2174 9L11.0837 6H12.9164L13.7827 9H10.2174ZM9.06229 13L7.90721 17H16.0929L14.9378 13H9.06229Z", fill: "currentColor" })));
const ForwardRef = forwardRef(SvgIcWorks24);
export { ForwardRef as ReactComponent };
